module.exports = __webpack_public_path__ + "img/pay-now.860d5cd3.svg";